module.exports = __webpack_public_path__ + "img/calibration-pic.1b21ec64.png";